import React from 'react';
import { Spinner } from 'react-bootstrap';

function Loader() {
    return (
        <div style={{ paddingTop: '20%' }}>
            <div className='text-center'>
                <Spinner
                    animation="border"
                    role="status"
                    style={{
                        height: '100px',
                        width: '100px',
                        margin: 'auto',
                        display: 'block'
                    }}
                >
                </Spinner>
            </div>
        </div>
    )
}

export default Loader;